/**
 * The per section <head> - the title and the favicon each section used to get from
 * its own MainXRouter.vue wrapper component.
 *
 * With one router there is one root component, so a section no longer has a
 * wrapper of its own to hang `metaInfo` on. It carries its head here instead, on
 * the `meta` of every top level route it owns, and SpaRoot applies whichever one
 * the current route matched.
 */
import FAVICONS from 'shared/favicons';

const DEFAULT_TITLE_TEMPLATE = '%s - Multi Me';

/**
 * @param {object} [options]
 * @param {string|function} [options.title] a title, or a function invoked with the
 *        root component as `this` - for the sections whose title goes through
 *        $customTerm
 * @param {string} [options.icon] favicon url, from shared/favicons
 * @param {string} [options.appleIcon] apple-touch-icon url, for the sections that have one
 * @param {string} [options.titleTemplate]
 * @returns {function} a metaInfo factory (see vue/plugins/vueMeta), called with the
 *          root component as `this`
 */
export default function sectionHead ({
    title = null,
    icon = FAVICONS.default,
    appleIcon = null,
    titleTemplate = DEFAULT_TITLE_TEMPLATE,
} = {}) {
    return function () {
        const link = [{rel: 'icon', href: icon, type: 'image/x-icon', vmid: 'favicon'}];
        if (appleIcon) {
            link.push({rel: 'apple-touch-icon', sizes: '180x180', href: appleIcon, vmid: 'apple-touch-icon'});
            link.push({
                rel: 'apple-touch-icon-precomposed',
                sizes: '180x180',
                href: appleIcon,
                vmid: 'apple-touch-icon-precomposed',
            });
        }
        const head = {titleTemplate, link};
        if (title) {
            head.title = (typeof title === 'function') ? title.call(this) : title;
        }
        return head;
    };
}

export {DEFAULT_TITLE_TEMPLATE};
